module.exports = __webpack_public_path__ + "static/media/apple-appstore-badge.bc588dbd.svg";